import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Modal } from '../../components/Modal/Modal'

interface LinkPhoneNumberModalProps {
  show: boolean
  onHide: () => void
}

export const LinkPhoneNumberModal: React.FC<LinkPhoneNumberModalProps> = ({ show, onHide }) => {
  const navigate = useNavigate()

  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<h4>Link Your Phone Number</h4>}
      body={<div>To switch to Phone Meeting, you need to connect your phone number to Zocks first.</div>}
      showFooterActions={true}
      footerPrimaryActionTitle='Go to Integrations'
      onFooterPrimaryAction={() => navigate('/account/profile-settings/integrations')}
    />
  )
}
